import useSWR from 'swr';
import { ReactElement, ReactNode } from 'react';
import type { ApplicationType, ConsumedLink } from './types';
import { InvoiceWidget } from 'modules/invoicing/common/InvoiceWidget';
import { sepFormat } from 'utilities';
import { Table, Card, Tbody, Td, Tr } from '@ff-it/ui';

type ConsumedLinksProps = {
  endpoint: string;
  type: ApplicationType;
  title?: ReactNode;
};

export function ConsumedLinks({ title, endpoint, type }: ConsumedLinksProps): ReactElement {
  const { data } = useSWR<ConsumedLink[], any, { suspense: true }>(
    { url: `${endpoint}${type}_consumed/`, method: 'GET' },
    { suspense: true },
  );

  return (
    <Card.Container testId={`consumed-links-${type}`} mb="3" width="full">
      <Card.Header>{title}</Card.Header>
      <Table size="xs" fixed>
        <Tbody>
          {data.map(({ amount, source }) => (
            <Tr key={source.id}>
              <Td>
                <InvoiceWidget invoice={source} link />
              </Td>
              <Td textAlign="right" style={{ width: '90px' }}>
                {sepFormat(amount)}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Card.Container>
  );
}
